
import React from 'react';

interface MetricCardProps {
  label: string;
  current: number;
  previous: number;
  isCurrency?: boolean;
  isPercentage?: boolean;
  isMultiplier?: boolean;
  description?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ 
  label, current = 0, previous = 0, isCurrency, isPercentage, isMultiplier, description 
}) => {
  const diff = current - previous;
  const percentChange = previous > 0 ? (diff / previous) * 100 : 0;
  const isPositive = diff >= 0;

  const formatValue = (val: number) => {
    const numericVal = val || 0;
    if (isCurrency) return numericVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    if (isPercentage) return `${numericVal.toFixed(1)}%`;
    if (isMultiplier) return `${numericVal.toFixed(1)}x`;
    return numericVal.toLocaleString('pt-BR');
  };

  return (
    <div className="bg-[#F8F9FA] p-7 rounded-[2.5rem] shadow-sm border border-slate-200 flex flex-col justify-between group hover:shadow-2xl transition-all duration-500 hover:-translate-y-1">
      <div>
        <div className="flex items-start justify-between mb-4">
          <p className="text-[11px] font-black text-slate-700 uppercase tracking-widest">{label}</p>
          <div className={`flex items-center gap-1.5 px-3 py-1 rounded-xl text-[10px] font-black shadow-sm ${
            isPositive 
              ? 'bg-green-100 text-green-700 border border-green-200' 
              : 'bg-red-100 text-red-700 border border-red-200'
          }`}>
            <span className="text-xs">{isPositive ? '↑' : '↓'}</span>
            {Math.abs(percentChange).toFixed(1)}%
          </div>
        </div>
        
        <div className="mb-4">
          <p className="text-3xl font-title font-black text-brand-navy leading-none tracking-tighter mb-2">
            {formatValue(current)}
          </p>
          <div className="flex items-center gap-2">
            <span className="text-[9px] font-black text-slate-400 uppercase tracking-tighter">Anterior:</span>
            <span className="text-[10px] font-bold text-slate-600">{formatValue(previous)}</span>
          </div>
        </div>

        {description && (
          <p className="text-[10px] leading-relaxed text-slate-600 font-medium italic border-l-4 border-brand-orange/30 pl-3 mt-4">
            {description}
          </p>
        )}
      </div>
      
      <div className="mt-8 pt-5 border-t-2 border-slate-100">
        <div className="flex items-center justify-between">
          <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest">Performance Mensal</span>
          <div className={`w-2 h-2 rounded-full ${isPositive ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.5)]' : 'bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.5)]'}`}></div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
